import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const grey = {
  100: '#FFFEFE',
  200: '#F7F7F7',
  250: '#F0F0F0',
  300: '#E7E7E7',
  400: '#B2B2B2',
  500: '#8C8C8C',
  600: '#676767',
  700: '#2F2F2F',
  800: '#1A1A1A',
  900: '#030303',
  // TODO: these definitions are in MUI but not with ours, see where used and defined them correctly
  50: '#B2B2B2',
  A100: '#B2B2B2',
  A200: '#B2B2B2',
  A400: '#B2B2B2',
  A700: '#B2B2B2',
} satisfies Partial<Color>
